import { useEffect, useState } from "react";

/**
 * A React hook for detecting Apple operating systems (macOS, iPadOS, iOS) on the client side.
 * @returns {{ isAppleOS: boolean; }} An object containing the following properties:
 *   - isAppleOS {boolean}: Indicates whether the user is on an Apple operating system.
 */
export function useNavigatorPlatform() {
    const [isAppleOS, setIsAppleOS] = useState(false);

    useEffect(() => {
        // Detect macOS, iPadOS, or iOS on the client side
        const platform = navigator.platform.toLowerCase();
        const userAgent = navigator.userAgent.toLowerCase();
        const updated_isAppleOS =
            platform.includes("mac") ||
            platform.includes("ipad") ||
            platform.includes("iphone") ||
            userAgent.includes("safari");
        setIsAppleOS(updated_isAppleOS);
    });

    return { isAppleOS };
}
